import { PickRequired } from '@frontend/types';
import { SchemaBrandSettingsService } from './service';
import { MergedSettings, QueryEndpointName } from './types';

export const STANDARD_QUERY_ENDPOINT_NAMES = [
  'Get',
  'List',
  'History',
] as const satisfies (keyof typeof SchemaBrandSettingsService)[];
export const INFINITE_QUERY_ENDPOINT_NAMES = [] as const satisfies (keyof Omit<
  typeof SchemaBrandSettingsService,
  (typeof STANDARD_QUERY_ENDPOINT_NAMES)[number]
>)[];
export const QUERY_ENDPOINT_NAMES = [...STANDARD_QUERY_ENDPOINT_NAMES, ...INFINITE_QUERY_ENDPOINT_NAMES] as const;

export const MUTATION_ENDPOINT_NAMES = ['Set', 'BatchSet', 'Revert'] as const satisfies (keyof Omit<
  typeof SchemaBrandSettingsService,
  QueryEndpointName
>)[];

export const DEFAULT_SETTINGS: PickRequired<MergedSettings, 'testSetting' | 'brandSetting'> = {
  testSetting: {
    enabled: false,
    values: [],
  },
  brandSetting: {
    customLinks: [],
    locationAddress: {
      address: '',
      address2: '',
      city: '',
      state: '',
      zipCode: '',
      country: '',
    },
    locationId: '',
    locationNickname: '',
    selectedPhoneNumberId: '',
    customSocialMediaLink: {
      platformName: '',
      url: '',
    },
  },
};
